import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
	Card,
	CardHeader,
	CardContent,
  Button,
  FormControl, InputLabel, Select, MenuItem, Box, LinearProgress, Input, ListItemText, Checkbox, IconButton, Popover, Chip, TextField, Typography
} from '@material-ui/core';
import { useQuery, useApolloClient } from '@apollo/client';
import _ from 'lodash';
import { NavLink } from 'react-router-dom';
import { VirtualizedTable } from 'components/Table/VirtualizedTable';
import { Table } from 'react-virtualized';
import { DuelLeaderboardFeedQuery, DuelLeaderboardFeedData, DuelLeaderboardFeedVars } from '@pvplevelup/core/dist/queries/duel/duelLeaderboardFeed';
import { Waypoint } from 'react-waypoint';
import { classImages } from 'utilities/ClassImages';
import { AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter';
import { LeaderboardSeasonsQuery, LeaderboardSeasonsData } from '@pvplevelup/core/dist/queries/leaderboard/seasons';
import { useMountedState } from 'components/useMountedState';
import { TeamColors } from 'utilities/team_colors';
import moment from 'moment';
import PlaceHolderImage from 'assets/images/icons/no_profile.jpg';
import { CalendarToday, SportsKabaddi } from '@material-ui/icons';
import { PageHeader, PageEmpty, PAGE_KIT, usePageStyles } from 'components/Page/PageKit';
import clsx from 'clsx';
import { DateRangePicker } from 'react-date-range';
import { ISeason } from '@pvplevelup/core/dist/interfaces/ISeason';

const useStyles = makeStyles((theme) => {
	return {
		cardCategoryWhite: {
			'&,& a,& a:hover,& a:focus': {
				color: 'rgba(255,255,255,.62)',
				margin: '0',
				fontSize: '14px',
				marginTop: '0',
				marginBottom: '0'
			},
			'& a,& a:hover,& a:focus': {
				color: '#FFFFFF'
			}
		},
		cardTitleWhite: {
			color: '#FFFFFF',
			marginTop: '0px',
			minHeight: 'auto',
			fontWeight: 'bold',
			fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
			marginBottom: '3px',
			textDecoration: 'none',
		},
		cardHeader: {
			padding: '0.75rem 1.25rem',
			marginBottom: '0',
			borderBottom: 'none',
			background: theme.palette.primary.main,
			zIndex: 3
    },
    classIcon: {
      width:'3em',
      cursor:'pointer'
    },
    link: {
      textDecoration: "none",
      color: "#6cbbff",
      "&:hover,&:focus": {
        color: "#FFF"
      }
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 100,
    },
    blueBarRoot:{
      height:10
    },
    blueBarBar:{
      background:TeamColors[0],
    },
    // filter row: every control is PAGE_KIT.controlHeight tall, dark and rounded like PageSearch
    filter: {
      minWidth: 130,
    },
    filterWide: {
      minWidth: 220,
      maxWidth: 360,
    },
    filterField: {
      '& .MuiOutlinedInput-root': {
        height: PAGE_KIT.controlHeight,
        borderRadius: 10,
        fontSize: '0.9rem',
        background: 'rgba(0, 0, 0, 0.3)',
        transition: 'box-shadow 0.15s',
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.25)',
        },
        '&.Mui-focused': {
          boxShadow: '0 0 0 3px rgba(66, 165, 245, 0.15)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: PAGE_KIT.accent,
          borderWidth: 1,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.1)',
      },
      // regular weight: the gap cut into the outline is measured for the theme's label, so a bolder one overruns it
      '& .MuiInputLabel-outlined': {
        color: PAGE_KIT.muted,
      },
      '& .MuiInputLabel-outlined.Mui-focused': {
        color: PAGE_KIT.accent,
      },
      '& .MuiSelect-icon': {
        color: PAGE_KIT.muted,
      },
    },
    selectedClasses: {
      display: 'inline-grid',
      gridAutoFlow: 'column',
      gridGap: 3,
      alignItems: 'center',
      verticalAlign: 'middle',
      '& img': {
        width: 18,
        height: 18,
        display: 'block',
      },
    },
    classOption: {
      width: 24,
      height: 24,
      marginRight: 8,
    },
    dateButton: {
      height: PAGE_KIT.controlHeight,
      padding: '0 14px',
      borderRadius: 10,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.9rem',
      whiteSpace: 'nowrap',
      color: 'rgba(255, 255, 255, 0.85)',
      background: 'rgba(0, 0, 0, 0.3)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.06)',
        borderColor: 'rgba(255, 255, 255, 0.25)',
      },
      '& .MuiButton-startIcon': {
        color: PAGE_KIT.muted,
      },
    },
    /** a date range is set */
    dateActive: {
      color: '#90caf9',
      borderColor: 'rgba(66, 165, 245, 0.45)',
      background: 'rgba(66, 165, 245, 0.08)',
      '& .MuiButton-startIcon': {
        color: PAGE_KIT.accent,
      },
    },
    resetButton: {
      height: PAGE_KIT.controlHeight,
      padding: '0 12px',
      borderRadius: 10,
      textTransform: 'none',
      fontWeight: 700,
      color: '#90caf9',
      '&.Mui-disabled': {
        color: PAGE_KIT.faint,
      },
    },
    count: {
      padding: '7px 12px',
      borderRadius: 10,
      fontSize: '0.82rem',
      whiteSpace: 'nowrap',
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      '& strong': {
        color: '#fff',
        fontWeight: 800,
        fontVariantNumeric: 'tabular-nums',
      },
    },
    // table
    table: {
      '& .MuiTableCell-body': {
        fontSize: '0.88rem',
        fontVariantNumeric: 'tabular-nums',
      },
    },
    rank: {
      display: 'grid',
      placeItems: 'center',
      minWidth: 30,
      height: 30,
      padding: '0 6px',
      boxSizing: 'border-box',
      borderRadius: 9,
      fontSize: '0.82rem',
      fontWeight: 800,
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.04)',
      border: '1px solid rgba(255, 255, 255, 0.07)',
    },
    player: {
      display: 'grid',
      gridTemplateColumns: '36px minmax(0, 1fr)',
      gridGap: 10,
      alignItems: 'center',
      width: '100%',
      minWidth: 0,
    },
    playerIcon: {
      width: 36,
      height: 36,
      padding: 3,
      boxSizing: 'border-box',
      borderRadius: 10,
      objectFit: 'cover',
      background: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    playerAvatar: {
      padding: 0,
      borderRadius: '50%',
    },
    playerName: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.92rem',
    },
    playerSub: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.75rem',
      color: PAGE_KIT.faint,
    },
    mmr: {
      fontSize: '1rem',
      fontWeight: 800,
      letterSpacing: '-0.01em',
      color: '#fff',
    },
    perf: {
      fontWeight: 800,
    },
    /** best / worst values: secondary to the current ones */
    dim: {
      color: PAGE_KIT.muted,
    },
    winRate: {
      width: '100%',
      paddingRight: 16,
    },
    winTop: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gridGap: 8,
      alignItems: 'baseline',
    },
    winPct: {
      fontWeight: 800,
    },
    winRecord: {
      justifySelf: 'end',
      fontSize: '0.75rem',
      color: PAGE_KIT.faint,
    },
    winTrack: {
      marginTop: 5,
      height: 4,
      borderRadius: 2,
      background: 'rgba(255, 255, 255, 0.07)',
      overflow: 'hidden',
    },
    winFill: {
      height: '100%',
      borderRadius: 2,
    },
    change: {
      padding: '2px 8px',
      borderRadius: 8,
      fontSize: '0.8rem',
      fontWeight: 700,
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.05)',
    }
	};
});

/** gold, silver and bronze medals for the top three */
const RANK_STYLES: Record<number, React.CSSProperties> = {
  1: {background: 'linear-gradient(135deg, #fbe08a, #c9a227)', color: '#2b2200', border: 0, boxShadow: '0 0 14px rgba(249, 217, 118, 0.35)'},
  2: {background: 'linear-gradient(135deg, #eef1f5, #9aa3ad)', color: '#1f2328', border: 0, boxShadow: '0 0 12px rgba(220, 225, 232, 0.22)'},
  3: {background: 'linear-gradient(135deg, #e9b07a, #a8652e)', color: '#2a1606', border: 0, boxShadow: '0 0 12px rgba(227, 167, 111, 0.25)'},
};

/** green for gains, red for losses */
const changeStyle = (change: number): React.CSSProperties | undefined => change > 0
  ? {color: '#66bb6a', background: 'rgba(102, 187, 106, 0.12)'}
  : change < 0 ? {color: '#ef5350', background: 'rgba(239, 83, 80, 0.12)'} : undefined;

/** red under 40%, amber around 50%, green over 60% */
const winRateColor = (rate: number) => rate >= 60 ? '#43a047' : rate >= 50 ? '#7cb342' : rate >= 40 ? '#fb8c00' : '#e53935';

const ALL_CLASSES = [AocClasses.Assassin,AocClasses.Barbarian,AocClasses.Ranger,
  AocClasses.BearShaman,AocClasses.TempestofSet,AocClasses.PriestofMitra,
  AocClasses.Demonologist,AocClasses.Necromancer,AocClasses.HeraldofXotli,
  AocClasses.Guardian,AocClasses.Conqueror,AocClasses.DarkTemplar];

interface Props {}

export const DuelLeaderboard: React.FC<Props> = (props) => {
  const classes = useStyles();
  const page = usePageStyles();
  const apolloClient = useApolloClient();
  const isMounted = useMountedState();

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [server,setServer] = useState<string>("Fury");
  const [season,setSeason] = useState<number>(1);
  const [seasons,setSeasons] = useState<ISeason[]>([]);
  const [ranked,setRanked] = useState<boolean>(true);
  const [byUser,setByUser] = useState<boolean>(false);
  const [selectedClasses, setSelectedClasses] = useState<string[]>([]);
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | undefined>();
  const gridRef = useRef<Table>(null);

  const [nextCursor, setNextCursor] = useState<string | undefined>("");
  const [hasNextCursor, setHasNextCursor] = useState<boolean | undefined>(false);
  const [isInitial, setIsInitial] = useState(true);

  const [showCalendar,setShowCalendar] = useState(false);
  const [calendarAnchor, setCalendarAnchor] = React.useState<HTMLButtonElement | null>(null);

	const { refetch, data, loading, fetchMore } = useQuery<DuelLeaderboardFeedData, DuelLeaderboardFeedVars>(DuelLeaderboardFeedQuery, {
    variables: {server,season,ranked,byUser,startDate,endDate,next:"",previous:""}
  });

  useEffect(()=>{
    apolloClient.query<LeaderboardSeasonsData>({query:LeaderboardSeasonsQuery}).then((res)=>{
      if(res.data && isMounted()){
        if(res.data.currentSeason){
          setSeason(res.data.currentSeason.season);
          setShouldRefetch(true);
        }
        setSeasons(res.data.seasons || []);
      }
    })
  },[])

  const getVariables = (): DuelLeaderboardFeedVars => ({classes:selectedClasses,ranked,season,byUser,server,startDate,endDate});

  const resetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedClasses([]);
    setNextCursor("");
    setHasNextCursor(true);
    setShouldRefetch(true);
  }

  const fetchMoreRecords = async ()=>{
    if((isInitial || hasNextCursor) && !loading){
      let variables = {...getVariables(), next: isInitial ? data?.duelLeaderboardFeed.next : nextCursor};
      let fetchMoreResult = await fetchMore({
        variables,
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev;
          let players = [...prev?.duelLeaderboardFeed?.players || [], ...fetchMoreResult.duelLeaderboardFeed.players];
          players = _.uniqBy(_.sortBy(players,(character)=>character.ranking),(character)=>character._id);
          return Object.assign({}, prev, {
            duelLeaderboardFeed:{
              ...fetchMoreResult.duelLeaderboardFeed,
              players,
            }
          });
        }
      })
      setIsInitial(false);
      if(fetchMoreResult.data){
        setNextCursor(fetchMoreResult.data.duelLeaderboardFeed.next);
        setHasNextCursor(fetchMoreResult.data.duelLeaderboardFeed.hasNext);
      }
    }
  }

  useEffect(()=>{
    if(shouldRefetch && isMounted()){
      if (typingTimeout) clearTimeout(typingTimeout);
      setTypingTimeout(
        setTimeout(async () => {
          let refetchResult = await refetch({...getVariables(), previous: "", next:""});
          if(refetchResult.data && isMounted()){
            setIsInitial(false);
            setNextCursor(refetchResult.data.duelLeaderboardFeed.next);
            setHasNextCursor(refetchResult.data.duelLeaderboardFeed.hasNext);
          }
          setShouldRefetch(false);
        }, 300)
      );
    }
  },[selectedClasses,shouldRefetch])

  const players = data?.duelLeaderboardFeed?.players || [];

  const seasonLabel = (s: ISeason) => `${s.label} (${moment(s.start,"YYYY-MM-DD").format("MMM Do YYYY")} - ${moment(s.end,"YYYY-MM-DD").format("MMM Do YYYY")})`;
  const filtered = selectedClasses.length > 0 || startDate != null || endDate != null;

  return (
		<Grid container spacing={2} className="content-container">
      <Grid item xs={12}>
        <PageHeader
          title="1v1 Leaderboard"
          subtitle={ranked ? 'Ranked duels: best of 3, through matchmaking.' : 'Unranked duels.'}
          icon={<SportsKabaddi />}
          actions={players.length > 0 ? <span className={classes.count}>Showing <strong>{players.length}</strong></span> : undefined}
          childrenStyle="filters"
        >
          <div className={page.filters}>
            <TextField select size="small" variant="outlined" label="Server" value={server} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setServer(event.target.value as string); setShouldRefetch(true); }}>
              <MenuItem value={`Fury`}>Fury</MenuItem>
              <MenuItem value={`Crom`}>Crom</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Leaderboard" value={byUser === true ? 1 : 0} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setByUser((event.target.value as any) == 1); setShouldRefetch(true); }}>
              <MenuItem value={0}>Characters</MenuItem>
              <MenuItem value={1}>Players</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Queue" value={ranked === true ? 1 : 0} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setRanked((event.target.value as any) == 1); setShouldRefetch(true); }}>
              <MenuItem value={1}>Ranked</MenuItem>
              <MenuItem value={0}>Unranked</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Season" value={season} className={clsx(classes.filterField, classes.filterWide)}
              onChange={(event) => { setSeason(Number(event.target.value)); setShouldRefetch(true); }}
              SelectProps={{renderValue: (selected: any) => {
                let found = seasons.find((s)=>s.season == selected);
                return selected == 0 ? 'All Time' : found ? seasonLabel(found) : "Season not found.";
              }}}>
              <MenuItem value={0}>All Time</MenuItem>
              {seasons.map((s) => <MenuItem key={s.season} value={s.season}>{seasonLabel(s)}</MenuItem>)}
            </TextField>
            <TextField select size="small" variant="outlined" label="Classes" value={selectedClasses} className={clsx(classes.filterField, classes.filterWide)}
              onChange={(event) => { setSelectedClasses(event.target.value as any as string[]); setShouldRefetch(true); }}
              SelectProps={{
                multiple: true,
                displayEmpty: true,
                renderValue: (selected: any) => (selected as string[]).length == 0
                  ? <span className={page.muted}>All classes</span>
                  : <span className={classes.selectedClasses}>{(selected as string[]).map((c) => <img key={c} src={classImages.getColorIcon(c as AocClasses)} title={c} />)}</span>,
              }}
              InputLabelProps={{shrink: true}}>
              {ALL_CLASSES.map((_class) => {
                let hasClass = selectedClasses.indexOf(_class) > -1;
                return (
                  <MenuItem key={_class} value={_class}>
                    <Checkbox size="small" checked={hasClass} />
                    <img className={classes.classOption} src={classImages.getColorIcon(_class)} title={_class} />
                    <ListItemText primary={_class} />
                  </MenuItem>
                )
              })}
            </TextField>
            <Button startIcon={<CalendarToday fontSize="small" />} className={clsx(classes.dateButton, {[classes.dateActive]: startDate != null})}
              onClick={(event)=>{setCalendarAnchor(event.currentTarget); setShowCalendar(true);}}>
              {startDate ? `${moment(startDate).format("MMM Do, YYYY")}${endDate ? ` - ${moment(endDate).format("MMM Do, YYYY")}` : ''}` : 'Any date'}
            </Button>
            <Button className={classes.resetButton} disabled={!filtered} onClick={resetFilters}>Reset filters</Button>
          </div>
        </PageHeader>
        <Popover
          open={showCalendar}
          anchorEl={calendarAnchor}
          onClose={()=>{setShowCalendar(false)}}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          transformOrigin={{vertical: 'top', horizontal: 'left'}}
        >
          <DateRangePicker
            ranges={[{startDate:startDate ? moment(startDate).toDate() : new Date(),endDate:endDate ? moment(endDate).toDate() : new Date(),key: 'selection'}]}
            onChange={(ranges: any)=>{
              setStartDate(moment(ranges.selection.startDate).toISOString());
              setEndDate(moment(ranges.selection.endDate).toISOString());
              setShouldRefetch(true);
            }}
          />
        </Popover>
      </Grid>
			<Grid item xs={12}>
        <div className={clsx(page.tablePanel, classes.table)} style={{overflowX: 'auto'}}>
          {loading && <LinearProgress style={{position: 'absolute', top: 0, left: 0, right: 0, height: 2, zIndex: 2}} />}
          <div style={{ height: 'calc(97vh - 300px)', minHeight: 360, width: '100%', minWidth:'955px'}}>
            <VirtualizedTable
              reference={gridRef}
              rowHeight={58}
              headerHeight={40}
              rowCount={players.length}
              rowGetter={({ index }) => players[index]}
              customCellRenderer={({columnIndex,rowIndex,cellData,rowData})=>{
                let decided = (rowData.wins + rowData.loses) || 1;
                const winRate = (rowData.wins / decided) * 100;
                const characterClass = rowData.character?.class as AocClasses;
                return (<React.Fragment>
                  {columnIndex == 0 ?
                    <span className={classes.rank} style={RANK_STYLES[cellData] || undefined}>{cellData}</span>
                  : columnIndex == 1 ?
                    // class icon (or avatar), name and a secondary line
                    <div className={classes.player}>
                      <img className={clsx(classes.playerIcon, {[classes.playerAvatar]: byUser})}
                        src={byUser ? rowData.user?.avatar || PlaceHolderImage : classImages.getColorIcon(characterClass)} title={byUser ? cellData : characterClass} />
                      <div style={{minWidth: 0}}>
                        <NavLink to={byUser ? `/users/${rowData._id}` : `/characters/${rowData._id}`} className={clsx(page.link, classes.playerName)}>{cellData}</NavLink>
                        <div className={classes.playerSub}>{byUser ? `${rowData.wins + rowData.loses} duels` : characterClass}</div>
                      </div>
                    </div>
                  : columnIndex == 2 ?
                    <span className={classes.mmr}>{cellData}</span>
                  : columnIndex == 3 ?
                    <div className={classes.winRate}>
                      <div className={classes.winTop}>
                        <span className={classes.winPct} style={{color: winRateColor(winRate)}}>{`${Math.round(winRate)}%`}</span>
                        <span className={classes.winRecord}>{`${rowData.wins}W ${rowData.loses}L`}</span>
                      </div>
                      <div className={classes.winTrack}>
                        <div className={classes.winFill} style={{width: `${winRate}%`, background: winRateColor(winRate)}} />
                      </div>
                    </div>
                  : columnIndex == 5 || columnIndex == 6 ?
                    <span className={classes.dim}>{cellData}</span>
                  : columnIndex == 7 && typeof cellData == 'number' ?
                    <span className={classes.change} style={changeStyle(cellData)}>{cellData > 0 ? `+${cellData}` : cellData}</span>
                  :
                    cellData
                  }
                  {(columnIndex == 0 && rowIndex == players.length - 3) &&
                    <Waypoint onEnter={async ()=>{ await fetchMoreRecords(); }} />
                  }
                </React.Fragment>)
              }}
              columns={[
                {width: 70, label: 'Rank', dataKey: 'ranking'},
                {width: 240, label: byUser ? 'Player' : 'Character', dataKey: byUser ? 'user.displayname' : 'character.name'},
                {width: 90, label: 'Mmr', dataKey: byUser ? 'ummr' : 'mmr', numeric: true},
                {width: 200, label: 'Win Rate', dataKey: 'wins'},
                {width: 85, label: 'Duels', dataKey: 'played', numeric: true},
                {width: 85, label: '▲ Mmr', dataKey: byUser ? 'maxummr' : 'maxmmr', numeric: true},
                {width: 85, label: '▼ Mmr', dataKey: byUser ? 'minummr' : 'minmmr', numeric: true},
                {width: 100, label: 'Mmr Change', dataKey: 'mmrChange', numeric: true}
              ]}
              data={players}
            />
          </div>
          {!loading && players.length == 0 &&
            <div style={{position: 'absolute', top: 40, left: 0, right: 0}}>
              <PageEmpty icon={<SportsKabaddi />}
                title={filtered ? 'No matches for these filters' : 'No duelists yet'}
                text={`No duelists on this leaderboard${filtered ? ' with these filters' : ''} yet.${filtered ? ' Try another class, season or date range.' : ' Rankings appear once duels are played.'}`}
                action={filtered ? <Button className={page.secondaryButton} onClick={resetFilters}>Reset filters</Button> : undefined} />
            </div>
          }
        </div>
			</Grid>
		</Grid>
	);
};

